import { useLocation } from 'react-router-dom';
import { ChatProvider } from '@/components/chat/ChatContext';
import ChatWidget from '@/components/chat/ChatWidget';
import FunnelFooter from '@/components/FunnelFooter';

const FunnelLayout = ({ children, enableChat = true, pageContext = 'default', hideFooterOnMobile = false }) => {
  const location = useLocation();
  
  // Get user name from session storage if available
  const getUserName = () => {
    try {
      const quoteData = sessionStorage.getItem('quoteData');
      if (quoteData) {
        const data = JSON.parse(quoteData);
        return data.firstName || '';
      }
    } catch (error) {
      console.error('Error loading user data:', error);
    }
    return '';
  };

  const userName = getUserName();

  // Map routes to page contexts
  const getPageContext = () => {
    const path = location.pathname;
    const contextMap = {
      '/': 'home',
      '/products': 'products',
      '/quote': 'quote',
      '/quote-results': 'quote-results',
      '/thank-you': 'thank-you',
      '/book-appointment': 'book-appointment',
      '/about': 'about'
    };
    return contextMap[path] || pageContext || 'default';
  };

  // Check if current page is a part-one application page
  const isPartOnePage = location.pathname.includes('/part-one');
  
  // Check if current page is a quote form page
  const isQuotePage = location.pathname.includes('/quote');
  
  // Disable chat on all form pages for less distraction and to avoid cut-off issues
  const shouldShowChat = enableChat && !isPartOnePage && !isQuotePage && location.pathname !== '/book-appointment';
  
  // Auto-hide footer on mobile for form pages, completely hide for part-one pages
  const isBookAppointmentPage = location.pathname === '/book-appointment';
  const shouldHideFooterOnMobile = hideFooterOnMobile || isQuotePage || isBookAppointmentPage;
  const footerClassName = isPartOnePage ? 'footer-hide-all' : (shouldHideFooterOnMobile ? 'footer-hide-mobile' : '');

  return (
    <ChatProvider>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <div style={{ flex: 1 }}>
          {children}
        </div>
        <div className={footerClassName}>
          <FunnelFooter />
        </div>
      </div>
      <ChatWidget 
        userName={userName} 
        pageContext={getPageContext()} 
        enabled={shouldShowChat}
      />
    </ChatProvider>
  );
};

export default FunnelLayout;

